import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "loading-popup flex-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createBlock(_component_van_overlay, {
    show: $props.isShowLoading,
    "z-index": 99999,
    "custom-style": {
      background: 'transparent'
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_loading, {
      color: "white"
    }), _cache[0] || (_cache[0] = _createElementVNode("span", {
      class: "loading-text"
    }, "加载中...", -1))])]),
    _: 1
  }, 8, ["show"]);
}